import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Icon from 'semantic-ui-react/dist/commonjs/elements/Icon';
import { greaterThanZero, requiredWithoutZero } from '../../../utils/validation';
import renderTextField from '../../form-controls/RenderTextField';
import { normalizeCurrency } from '../../../utils/validation/restrictions';
import {
  fontSizeAdjust,
  formatCurrencyAmount,
  parseCurrency,
  computeWithTxn,
  setNoIcon,
  amountOrCurrencyChangeCT
} from '../../../utils/library';
import { Field } from 'redux-form';
import RenderCommonDropdownField from '../../form-controls/RenderCommonDropdownField';
import './style.css';
import { CORPORATE, FLAG_URL, FORMNAME_MULTI_TRANSACTIONS } from '../../../utils/constants';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { PARAMETER_CHANGE } from '../../../utils/constants/eventsConstants';
import { disableSubmit } from '../../../redux/actions/transaction/transaction-action';
import { DOT_LOADER_ICON, GREY_DOWN_ARROW_ICON } from '@Images';

class CurrencyField extends Component {
  constructor(props) {
    super(props);
    this.inputRef = null;
    this.dropDownRef = React.createRef();
    this.state = {
      showDisabledWithIcon: true
    };
  }

  componentDidUpdate = (prevProps) => {
    const { showLoader, amountField, is_destination_amount_last_changed } = this.props;
    if (showLoader !== prevProps.showLoader && this.inputRef) {
      if (
        (!is_destination_amount_last_changed && amountField === 'gross_source_amount') ||
        (is_destination_amount_last_changed && amountField !== 'gross_source_amount')
      ) {
        this.inputRef.focus();
      }
    }
  };

  getInputRef = (ref) => (this.inputRef = ref);
  showDropDownIcon = () => this.setState({ showDisabledWithIcon: true });

  handleParseCurrency = (value) => {
    const { currencyField, currency } = this.props;
    const dontAllowDecimal = currencyField === 'destination_currency' && currency === 'CLP';
    return parseCurrency(value, dontAllowDecimal);
  };

  trackAndCompute = (value, isSourceAmountChanged, amountChanged) => {
    const { currencyField, mainConverter, disableSubmit } = this.props;
    disableSubmit(true);
    let event_name = '';
    if (amountChanged) {
      computeWithTxn(mainConverter, isSourceAmountChanged);
      event_name = isSourceAmountChanged
        ? PARAMETER_CHANGE.SOURCE_AMOUNT_CHANGE
        : PARAMETER_CHANGE.DESTINATION_AMOUNT_CHANGE;
    } else {
      event_name =
        currencyField === 'destination_currency'
          ? PARAMETER_CHANGE.DESTINATION_CURRENCY_CHANGE
          : PARAMETER_CHANGE.SOURCE_CURRENCY_CHANGE;
    }
    amountOrCurrencyChangeCT(value, event_name);
  };
  render() {
    let {
      showLoader,
      amountField,
      amount = 0,
      currency,
      currencyField,
      className = '',
      urldependent,
      error,
      isSearchable = true,
      url,
      dependedOnObject,
      placeholder,
      showDefaultPlaceholder,
      showDisabledWithIcon,
      country_code,
      featureToggle: {
        featureToggle: { toggleFeature }
      },
      formName
    } = this.props;
    if (!currency) return null;
    let noIcon = setNoIcon({ currencyField, country_code, toggleFeature });
    const options = get(this.dropDownRef, 'current.state.options', []);
    if (!isEmpty(options) && currencyField === 'source_currency') {
      noIcon = options.length === 1;
    }
    const showDisabledWithIconCheck =
      this.props.user_session.account_type === CORPORATE && !toggleFeature
        ? showDisabledWithIcon
        : !this.state.showDisabledWithIcon || noIcon;
    const noBorder = {
      border: toggleFeature && 'none',
      boxShadow: toggleFeature && 'none'
    };
    const isCorpSendMoney = formName === FORMNAME_MULTI_TRANSACTIONS;
    return (
      <div
        className={
          toggleFeature
            ? ['currency-field-us-flow no-border-no-shadow', className].join(' ')
            : ['currency-field', className].join(' ')
        }
        style={noBorder}
      >
        <Field
          key={1}
          type="text"
          getInputRef={this.getInputRef}
          name={amountField}
          component={renderTextField}
          errFromParent={error}
          validate={[requiredWithoutZero, greaterThanZero]}
          normalize={normalizeCurrency}
          disableUnderlineStyling={true}
          format={formatCurrencyAmount}
          parse={this.handleParseCurrency}
          parentClassName={
            this.props.featureToggle.featureToggle.toggleFeature
              ? `  bold-text-us`
              : `${fontSizeAdjust(amount)} bold-text-us`
          }
          placeholder={placeholder || ''}
          showDefaultPlaceholder={showDefaultPlaceholder}
          onChange={(e) =>
            this.trackAndCompute(e.target.value, amountField === 'gross_source_amount', true)
          }
          disabled={showLoader}
          onBlur={(e) => {
            e.preventDefault();
          }}
        />
        {showLoader && <img src={DOT_LOADER_ICON} alt="loading" className="dot-loader" />}
        <Field
          bindToThisObject={currency}
          name={currencyField}
          toggleFeature={this.props.featureToggle.featureToggle.toggleFeature}
          component={RenderCommonDropdownField}
          onDropdownChange={(obj) => this.trackAndCompute(obj.value, false, false)}
          dependedOnObject={urldependent ? dependedOnObject : undefined}
          fluid={true}
          isSearchable={isSearchable}
          showDisabledWithIcon={showDisabledWithIconCheck}
          url={url}
          className={`bold-text-us ${isCorpSendMoney ? 'send-money-no-padding' : ''}`}
          showImage={true}
          $noDropdownIcon={noIcon}
          showDropDownIcon={this.showDropDownIcon}
          onBlur={(e) => {
            e.preventDefault();
          }}
          parentRef={this.dropDownRef}
        />
        <img
          src={`${FLAG_URL}${currency.toLowerCase()}.png`}
          alt={`${className} currency`}
          className="flag"
        />
        {showDisabledWithIcon ? (
          <Icon className="dropdown-light lock-icon" name="lock" size="large" />
        ) : this.state.showDisabledWithIcon && !noIcon ? (
          <img src={GREY_DOWN_ARROW_ICON} alt="dropdown" className="dropdown-light" />
        ) : (
          ''
        )}
      </div>
    );
  }
}
/**to not  break in corporate  */
CurrencyField.defaultProps = {
  featureToggle: { featureToggle: { toggleFeature: false } }
};
CurrencyField.propTypes = {
  flowType: PropTypes.any,
  country_code: PropTypes.string,
  account_type: PropTypes.string,
  showLoader: PropTypes.bool,
  amount: PropTypes.any,
  isSearchable: PropTypes.bool,
  user_session: PropTypes.object,
  amountField: PropTypes.string,
  currencyField: PropTypes.string,
  dependedOnObject: PropTypes.any,
  currency: PropTypes.string,
  className: PropTypes.string,
  error: PropTypes.string,
  url: PropTypes.string,
  urldependent: PropTypes.bool,
  placeholder: PropTypes.string,
  showDefaultPlaceholder: PropTypes.bool,
  showDisabledWithIcon: PropTypes.bool,
  is_destination_amount_last_changed: PropTypes.any,
  mainConverter: PropTypes.any,
  featureToggle: PropTypes.any,
  formName: PropTypes.string,
  disableSubmit: PropTypes.func
};

export default connect(null, { disableSubmit })(CurrencyField);
